import React from 'react';
import { Checkbox } from 'antd';
import styled from 'styled-components';
import { GlobalToken } from 'antd';

const EPCheckbox = ({ children, ...rest }: { children?: string | JSX.Element; [x: string]: unknown }) => {
  return <StyledCheckbox {...rest}>{children}</StyledCheckbox>;
};

const StyledCheckbox = styled(Checkbox)<{ theme: { token: GlobalToken } }>`
  &.ant-checkbox-wrapper {
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    white-space: nowrap;
  }

  .ant-checkbox {
    &.ant-checkbox-inner {
      outline: 2px solid ${({ theme: { token } }) => token.colorPrimary};
    }

    &.ant-checkbox-checked {
      .ant-checkbox-inner {
        background-color: ${({ theme: { token } }) => token.colorPrimary};
        border-color: ${({ theme: { token } }) => token.colorPrimary};
        outline: 2px solid ${({ theme: { token } }) => token.colorPrimary};

        &::after {
          border-color: ${({ theme: { token } }) => token.colorText};
        }
      }
    }
  }

  .ant-checkbox-disabled {
    .ant-checkbox-inner {
      outline: 2px solid ${({ theme: { token } }) => token.colorBorder};
    }

    + span {
      color: ${({ theme: { token } }) => token.colorBorder};
    }
  }
`;

export default EPCheckbox;
